import { render } from "./VerpalReport.vue?vue&type=template&id=20e7dd74&ts=true"
import script from "./VerpalReport.vue?vue&type=script&lang=ts"
export * from "./VerpalReport.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__